import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="mt-20 border-t border-white/5 bg-[hsl(var(--surface))] px-6 py-10 md:px-12">
      <div className="mx-auto flex max-w-[1600px] flex-col gap-4 md:flex-row md:items-center md:justify-between">
        <div>
          <span className="font-heading text-lg font-black tracking-tight">
            Vytali<span className="text-primary">Flix</span>
          </span>
          <p className="mt-1 text-sm text-muted-foreground">{t("brand.tagline")}</p>
        </div>
        <p className="text-xs text-muted-foreground">
          © {new Date().getFullYear()} VytaliFlix · Accès libre · {t("common.demoNotice")}
        </p>
      </div>
    </footer>
  );
}
